import { render } from "./MultiFileUploader.vue?vue&type=template&id=677954b3"
import script from "./MultiFileUploader.vue?vue&type=script&lang=js"
export * from "./MultiFileUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__